import { render, staticRenderFns } from "./VQCompanyHouseName.vue?vue&type=template&id=4179f9de&scoped=true&"
import script from "./VQCompanyHouseName.vue?vue&type=script&lang=js&"
export * from "./VQCompanyHouseName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4179f9de",
  null
  
)

export default component.exports